/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Leerjaar_Zes2Inputs */

const nl_enums_leerjaar_zes2 = /** @type {(inputs: Enums_Leerjaar_Zes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leerjaar 6`)
};

/**

* @param {Enums_Leerjaar_Zes2Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_leerjaar_zes2 = /** @type {((inputs?: Enums_Leerjaar_Zes2Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Leerjaar_Zes2Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_leerjaar_zes2(inputs)
});
export { enums_leerjaar_zes2 as "enums.Leerjaar.Zes" }